import { Box, Typography } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';

export default function BrandLogo({
  iconSize = 36,
  compact = false,
  onClick,
  sx = {},
}) {
  return (
    <Box
      role='img'
      aria-label='Get Your Site Today'
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 1 : 1.25,
        cursor: onClick ? 'pointer' : 'default',
        ...sx,
      }}
    >
      <Box
        sx={{
          width: iconSize,
          height: iconSize,
          background: 'linear-gradient(135deg, #7C3AED, #06B6D4)',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <CodeIcon sx={{ fontSize: iconSize * 0.56, color: '#fff' }} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 0.95 }}>
        <Typography
          component='span'
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 800,
            fontSize: compact ? '0.95rem' : '1rem',
            background: 'linear-gradient(135deg, #fff, #94A3B8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.5px',
          }}
        >
          Get Your
        </Typography>
        <Typography
          component='span'
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 800,
            fontSize: compact ? '0.68rem' : '0.74rem',
            color: '#F59E0B',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
          }}
        >
          Site Today
        </Typography>
      </Box>
    </Box>
  );
}
